// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-detail {
  max-width: 1200px;
}

.user-detail-loading,
.user-detail-error {
  text-align: center;
  padding: 40px;
  color: #666;
}

.user-detail-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
}

.back-button {
  padding: 8px 16px;
  background: #666;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.back-button:hover {
  background: #555;
}

.user-detail-header h2 {
  margin: 0;
  flex: 1 1;
  color: #333;
  font-size: 24px;
}

.edit-button {
  padding: 8px 16px;
  background: #1976d2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.edit-button:hover {
  background: #1565c0;
}

.user-detail-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detail-section {
  background: white;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.detail-section h3 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 18px;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 10px;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.detail-item label {
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
  font-weight: 600;
}

.detail-value {
  font-size: 14px;
  color: #333;
}

.detail-item input {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-badge.active {
  background: #4caf50;
  color: white;
}

.status-badge.inactive {
  background: #f44336;
  color: white;
}

.status-badge.trial {
  background: #ff9800;
  color: white;
}

.edit-actions {
  display: flex;
  gap: 10px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}

.save-button {
  padding: 10px 20px;
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.save-button:hover {
  background: #45a049;
}

.cancel-button {
  padding: 10px 20px;
  background: #666;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.cancel-button:hover {
  background: #555;
}

.whatsapp-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.whatsapp-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: #f5f5f5;
  border-radius: 8px;
  margin-bottom: 10px;
}

.btn-disconnect {
  padding: 6px 12px;
  background: #f44336;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

.btn-disconnect:hover {
  background: #d32f2f;
}

.activity-subsection {
  margin-bottom: 30px;
}

.activity-subsection h4 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
}

.activity-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.activity-item {
  padding: 12px;
  background: #f5f5f5;
  border-radius: 4px;
  border-left: 3px solid #1976d2;
}

.activity-action {
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
}

.activity-details {
  display: flex;
  gap: 15px;
  font-size: 12px;
  color: #666;
  flex-wrap: wrap;
}

.activity-details .success {
  color: #4caf50;
}

.activity-details .failure {
  color: #f44336;
}

.activity-subsection h4 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
}

.activity-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.activity-item {
  padding: 12px;
  background: #f5f5f5;
  border-radius: 4px;
  border-left: 3px solid #1976d2;
}

.activity-action {
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
}

.activity-details {
  display: flex;
  gap: 15px;
  font-size: 12px;
  color: #666;
  flex-wrap: wrap;
}

.activity-details .success {
  color: #4caf50;
}

.activity-details .failure {
  color: #f44336;
}

.wa-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.wa-phone {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.wa-meta {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.wa-type {
  padding: 4px 8px;
  background: #1976d2;
  color: white;
  border-radius: 4px;
  font-size: 11px;
  text-transform: uppercase;
}

.wa-status {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
}

.wa-status.connected {
  background: #4caf50;
  color: white;
}

.wa-status.disconnected {
  background: #f44336;
  color: white;
}

.wa-verified {
  padding: 4px 8px;
  background: #4caf50;
  color: white;
  border-radius: 4px;
  font-size: 11px;
}

.no-data {
  text-align: center;
  padding: 20px;
  color: #999;
}

/* ── Social Connections ── */
.social-connections-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.social-conn-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  transition: box-shadow 0.15s;
}

.social-conn-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.social-conn-card.not-connected {
  opacity: 0.7;
}

.social-conn-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  background: #f8fafc;
  border-top: 3px solid #ccc;
}

.social-conn-icon {
  font-size: 1.3rem;
}

.social-conn-platform {
  font-weight: 600;
  font-size: 0.95rem;
  color: #1e293b;
  flex: 1 1;
}

.social-conn-badge {
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.badge-connected {
  background: #d1fae5;
  color: #065f46;
}

.badge-not-connected {
  background: #f1f5f9;
  color: #64748b;
}

.social-conn-body {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.social-conn-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
}

.social-conn-label {
  color: #64748b;
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.social-conn-value {
  color: #1e293b;
  font-weight: 500;
}

.social-conn-token.token-valid {
  color: #16a34a;
  font-weight: 600;
  font-size: 0.85rem;
}

.social-conn-token.token-expired {
  color: #dc2626;
  font-weight: 600;
  font-size: 0.85rem;
}

.social-conn-empty {
  padding: 20px 16px;
  text-align: center;
  color: #94a3b8;
  font-size: 0.88rem;
  font-style: italic;
}

@media (max-width: 768px) {
  .social-connections-grid {
    grid-template-columns: 1fr;
  }
}


/* ── Feature Flags ── */

.feature-flags-description {
  color: #666;
  font-size: 13px;
  margin-bottom: 16px;
}

.feature-flags-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
}

.feature-flag-card {
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 16px;
  transition: box-shadow 0.2s, border-color 0.2s;
}

.feature-flag-card.enabled {
  border-color: #22c55e;
  background: #f0fdf4;
}

.feature-flag-card.disabled {
  border-color: #e5e7eb;
  background: #fafafa;
}

.feature-flag-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.feature-flag-icon {
  font-size: 20px;
}

.feature-flag-label {
  font-weight: 600;
  font-size: 14px;
  flex: 1 1;
}

.feature-flag-desc {
  color: #666;
  font-size: 12px;
  margin: 0;
  line-height: 1.4;
}

/* Toggle switch */
.feature-flag-toggle {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  flex-shrink: 0;
}

.feature-flag-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: #ccc;
  border-radius: 24px;
  transition: 0.3s;
}

.toggle-slider::before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  border-radius: 50%;
  transition: 0.3s;
}

.feature-flag-toggle input:checked+.toggle-slider {
  background-color: #22c55e;
}

.feature-flag-toggle input:checked+.toggle-slider::before {
  transform: translateX(20px);
}

/* Per-platform child cards — indented */
.feature-flag-child {
  margin-left: 12px;
  border-left: 3px solid #d1d5db;
}

.feature-flag-child.enabled {
  border-left-color: #22c55e;
}

/* Master card accent */
.feature-flag-master.enabled {
  border-color: #3b82f6;
  background: #eff6ff;
}

/* Locked indicator when parent is off */
.feature-flag-locked {
  font-size: 14px;
  opacity: 0.7;
}

/* Disabled toggle when parent is off */
.feature-flag-toggle input:disabled + .toggle-slider {
  opacity: 0.4;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .feature-flags-grid {
    grid-template-columns: 1fr;
  }
}
/* ── Granted-OAuth-scopes panel (superadmin-only) ── */
.detail-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.detail-section-header h3 {
  margin: 0;
}

.social-scopes-controls {
  display: flex;
  gap: 0.5rem;
}

.btn-show-scopes,
.btn-show-scopes-refresh {
  padding: 0.4rem 0.85rem;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #f8fafc;
  font-size: 0.85rem;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.btn-show-scopes:hover:not(:disabled),
.btn-show-scopes-refresh:hover:not(:disabled) {
  background: #e2e8f0;
  border-color: #94a3b8;
}

.btn-show-scopes:disabled,
.btn-show-scopes-refresh:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.social-scopes-error {
  background: #fee2e2;
  color: #991b1b;
  border: 1px solid #fca5a5;
  padding: 0.6rem 0.9rem;
  border-radius: 6px;
  margin-bottom: 0.75rem;
  font-size: 0.9rem;
}

/* Inner panel styles live in admin/components/ScopesPanel.css —
   imported automatically by the ScopesPanel component so both
   UserDetail and SocialAccounts get them without any duplication. */

/* ── Voice review (recording + cloned voice) ── */
.voice-review-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1rem;
}

.voice-review-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0.9rem 1rem;
  background: #fafafa;
}

.voice-review-title {
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #374151;
}

.voice-review-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 0.9rem;
  font-size: 0.85rem;
  color: #555;
  align-items: center;
}

.voice-review-meta .success {
  color: #166534;
  font-weight: 600;
}

.voice-review-meta .failure {
  color: #991b1b;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/admin/pages/UserDetail.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,SAAO;EACP,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;;AAGA,wBAAwB;;AAExB;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAO;AACT;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA,uDAAuD;AACvD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gDAAgD;AAClD;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;oEAEoE;;AAEpE,kDAAkD;AAClD;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".user-detail {\n  max-width: 1200px;\n}\n\n.user-detail-loading,\n.user-detail-error {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n.user-detail-header {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 20px;\n}\n\n.back-button {\n  padding: 8px 16px;\n  background: #666;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.back-button:hover {\n  background: #555;\n}\n\n.user-detail-header h2 {\n  margin: 0;\n  flex: 1;\n  color: #333;\n  font-size: 24px;\n}\n\n.edit-button {\n  padding: 8px 16px;\n  background: #1976d2;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.edit-button:hover {\n  background: #1565c0;\n}\n\n.user-detail-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.detail-section {\n  background: white;\n  padding: 24px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.detail-section h3 {\n  margin: 0 0 20px 0;\n  color: #333;\n  font-size: 18px;\n  border-bottom: 2px solid #e0e0e0;\n  padding-bottom: 10px;\n}\n\n.detail-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n.detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.detail-item label {\n  font-size: 12px;\n  color: #666;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n\n.detail-value {\n  font-size: 14px;\n  color: #333;\n}\n\n.detail-item input {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.status-badge.active {\n  background: #4caf50;\n  color: white;\n}\n\n.status-badge.inactive {\n  background: #f44336;\n  color: white;\n}\n\n.status-badge.trial {\n  background: #ff9800;\n  color: white;\n}\n\n.edit-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.save-button {\n  padding: 10px 20px;\n  background: #4caf50;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.save-button:hover {\n  background: #45a049;\n}\n\n.cancel-button {\n  padding: 10px 20px;\n  background: #666;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.cancel-button:hover {\n  background: #555;\n}\n\n.whatsapp-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.whatsapp-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px;\n  background: #f5f5f5;\n  border-radius: 8px;\n  margin-bottom: 10px;\n}\n\n.btn-disconnect {\n  padding: 6px 12px;\n  background: #f44336;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n.btn-disconnect:hover {\n  background: #d32f2f;\n}\n\n.activity-subsection {\n  margin-bottom: 30px;\n}\n\n.activity-subsection h4 {\n  margin: 0 0 15px 0;\n  color: #333;\n  font-size: 16px;\n}\n\n.activity-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.activity-item {\n  padding: 12px;\n  background: #f5f5f5;\n  border-radius: 4px;\n  border-left: 3px solid #1976d2;\n}\n\n.activity-action {\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 5px;\n}\n\n.activity-details {\n  display: flex;\n  gap: 15px;\n  font-size: 12px;\n  color: #666;\n  flex-wrap: wrap;\n}\n\n.activity-details .success {\n  color: #4caf50;\n}\n\n.activity-details .failure {\n  color: #f44336;\n}\n\n.activity-subsection h4 {\n  margin: 0 0 15px 0;\n  color: #333;\n  font-size: 16px;\n}\n\n.activity-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.activity-item {\n  padding: 12px;\n  background: #f5f5f5;\n  border-radius: 4px;\n  border-left: 3px solid #1976d2;\n}\n\n.activity-action {\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 5px;\n}\n\n.activity-details {\n  display: flex;\n  gap: 15px;\n  font-size: 12px;\n  color: #666;\n  flex-wrap: wrap;\n}\n\n.activity-details .success {\n  color: #4caf50;\n}\n\n.activity-details .failure {\n  color: #f44336;\n}\n\n.wa-info {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.wa-phone {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n.wa-meta {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.wa-type {\n  padding: 4px 8px;\n  background: #1976d2;\n  color: white;\n  border-radius: 4px;\n  font-size: 11px;\n  text-transform: uppercase;\n}\n\n.wa-status {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.wa-status.connected {\n  background: #4caf50;\n  color: white;\n}\n\n.wa-status.disconnected {\n  background: #f44336;\n  color: white;\n}\n\n.wa-verified {\n  padding: 4px 8px;\n  background: #4caf50;\n  color: white;\n  border-radius: 4px;\n  font-size: 11px;\n}\n\n.no-data {\n  text-align: center;\n  padding: 20px;\n  color: #999;\n}\n\n/* ── Social Connections ── */\n.social-connections-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 16px;\n}\n\n.social-conn-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  overflow: hidden;\n  transition: box-shadow 0.15s;\n}\n\n.social-conn-card:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.social-conn-card.not-connected {\n  opacity: 0.7;\n}\n\n.social-conn-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 16px;\n  background: #f8fafc;\n  border-top: 3px solid #ccc;\n}\n\n.social-conn-icon {\n  font-size: 1.3rem;\n}\n\n.social-conn-platform {\n  font-weight: 600;\n  font-size: 0.95rem;\n  color: #1e293b;\n  flex: 1;\n}\n\n.social-conn-badge {\n  padding: 3px 8px;\n  border-radius: 12px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.badge-connected {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.badge-not-connected {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.social-conn-body {\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.social-conn-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.85rem;\n}\n\n.social-conn-label {\n  color: #64748b;\n  font-size: 0.78rem;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.social-conn-value {\n  color: #1e293b;\n  font-weight: 500;\n}\n\n.social-conn-token.token-valid {\n  color: #16a34a;\n  font-weight: 600;\n  font-size: 0.85rem;\n}\n\n.social-conn-token.token-expired {\n  color: #dc2626;\n  font-weight: 600;\n  font-size: 0.85rem;\n}\n\n.social-conn-empty {\n  padding: 20px 16px;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 0.88rem;\n  font-style: italic;\n}\n\n@media (max-width: 768px) {\n  .social-connections-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n\n/* ── Feature Flags ── */\n\n.feature-flags-description {\n  color: #666;\n  font-size: 13px;\n  margin-bottom: 16px;\n}\n\n.feature-flags-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 16px;\n}\n\n.feature-flag-card {\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  padding: 16px;\n  transition: box-shadow 0.2s, border-color 0.2s;\n}\n\n.feature-flag-card.enabled {\n  border-color: #22c55e;\n  background: #f0fdf4;\n}\n\n.feature-flag-card.disabled {\n  border-color: #e5e7eb;\n  background: #fafafa;\n}\n\n.feature-flag-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.feature-flag-icon {\n  font-size: 20px;\n}\n\n.feature-flag-label {\n  font-weight: 600;\n  font-size: 14px;\n  flex: 1;\n}\n\n.feature-flag-desc {\n  color: #666;\n  font-size: 12px;\n  margin: 0;\n  line-height: 1.4;\n}\n\n/* Toggle switch */\n.feature-flag-toggle {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.feature-flag-toggle input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  inset: 0;\n  background-color: #ccc;\n  border-radius: 24px;\n  transition: 0.3s;\n}\n\n.toggle-slider::before {\n  content: \"\";\n  position: absolute;\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  border-radius: 50%;\n  transition: 0.3s;\n}\n\n.feature-flag-toggle input:checked+.toggle-slider {\n  background-color: #22c55e;\n}\n\n.feature-flag-toggle input:checked+.toggle-slider::before {\n  transform: translateX(20px);\n}\n\n/* Per-platform child cards — indented */\n.feature-flag-child {\n  margin-left: 12px;\n  border-left: 3px solid #d1d5db;\n}\n\n.feature-flag-child.enabled {\n  border-left-color: #22c55e;\n}\n\n/* Master card accent */\n.feature-flag-master.enabled {\n  border-color: #3b82f6;\n  background: #eff6ff;\n}\n\n/* Locked indicator when parent is off */\n.feature-flag-locked {\n  font-size: 14px;\n  opacity: 0.7;\n}\n\n/* Disabled toggle when parent is off */\n.feature-flag-toggle input:disabled + .toggle-slider {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .feature-flags-grid {\n    grid-template-columns: 1fr;\n  }\n}\n/* ── Granted-OAuth-scopes panel (superadmin-only) ── */\n.detail-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n}\n\n.detail-section-header h3 {\n  margin: 0;\n}\n\n.social-scopes-controls {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.btn-show-scopes,\n.btn-show-scopes-refresh {\n  padding: 0.4rem 0.85rem;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  background: #f8fafc;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.btn-show-scopes:hover:not(:disabled),\n.btn-show-scopes-refresh:hover:not(:disabled) {\n  background: #e2e8f0;\n  border-color: #94a3b8;\n}\n\n.btn-show-scopes:disabled,\n.btn-show-scopes-refresh:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.social-scopes-error {\n  background: #fee2e2;\n  color: #991b1b;\n  border: 1px solid #fca5a5;\n  padding: 0.6rem 0.9rem;\n  border-radius: 6px;\n  margin-bottom: 0.75rem;\n  font-size: 0.9rem;\n}\n\n/* Inner panel styles live in admin/components/ScopesPanel.css —\n   imported automatically by the ScopesPanel component so both\n   UserDetail and SocialAccounts get them without any duplication. */\n\n/* ── Voice review (recording + cloned voice) ── */\n.voice-review-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 1rem;\n}\n\n.voice-review-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 0.9rem 1rem;\n  background: #fafafa;\n}\n\n.voice-review-title {\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: #374151;\n}\n\n.voice-review-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem 0.9rem;\n  font-size: 0.85rem;\n  color: #555;\n  align-items: center;\n}\n\n.voice-review-meta .success {\n  color: #166534;\n  font-weight: 600;\n}\n\n.voice-review-meta .failure {\n  color: #991b1b;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
